import React from 'react';
import * as PropTypes from 'prop-types';
import { connect, getIn, useFormikContext } from 'formik';

import { withStyles } from '~/assets/withStyles';
import FormControl from '~/components/core/Atomic/FormControl';
import FormControlLabel from '~/components/core/Atomic/FormControlLabel';
import FormHelperText from '~/components/core/Atomic/FormHelperText';
import Typography from '~/components/core/Atomic/Typography';
import Checkbox from '~/components/ui/atoms/Checkbox';

import PencilIcon from './icons/PencilIcon';
import InlineIconButton from './InlineIconButton';

import styles, { useStyles } from '../assets/styles';

function CheckboxFormik(props) {
  const { id, label, showOnly, disabled, onEdit, onChange, containerClassName, checkboxClassName, size } = props;

  const { values, touched, errors, setFieldTouched, setFieldValue } = useFormikContext();

  if (showOnly) {
    return (
      <ShowOnlyCheckbox label={label} showOnlyValueComponent={getIn(values, id)} disabled={disabled} onEdit={onEdit} />
    );
  }

  return (
    <FormControl className={containerClassName} component="fieldset" error={getIn(errors, id) && getIn(touched, id)}>
      <div className="flex flex-wrap">
        <FormControlLabel
          control={
            <Checkbox
              className={checkboxClassName}
              checked={!!getIn(values, id)}
              disabled={showOnly || disabled}
              onChange={onChange ? onChange : (event) => setFieldValue(id, event.target.checked)}
              onBlur={() => setFieldTouched(id, true)}
              size={size}
            />
          }
          label={label}
        />
      </div>
      {getIn(errors, id) && getIn(touched, id) && <FormHelperText>{getIn(errors, id)}</FormHelperText>}
    </FormControl>
  );
}

CheckboxFormik.propTypes = {
  id: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  label: PropTypes.node.isRequired,
  showOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onEdit: PropTypes.func,
  onChange: PropTypes.func,
  checkboxClassName: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'small', 'medium']),
};

function ShowOnlyCheckbox(props) {
  const { label, disabled, onEdit, showOnlyValueComponent } = props;
  const { classes } = useStyles();

  const isEditable = onEdit && !disabled;

  return (
    <div className={classes.showField}>
      <div className="inline-flex items-center whitespace-pre-wrap">
        <Checkbox checked={Boolean(showOnlyValueComponent)} disabled={true} />
        <Typography display="block" variant="caption">
          {label}
        </Typography>
        {isEditable && (
          <InlineIconButton className={classes.inlineEditIcon} icon={PencilIcon} onClick={(e) => onEdit(e)} />
        )}
      </div>
    </div>
  );
}

ShowOnlyCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  showOnlyValueComponent: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onEdit: PropTypes.func,
};

export { ShowOnlyCheckbox };
export default connect(withStyles(CheckboxFormik, styles));
